import XLSX from 'xlsx';

function string_to_slug (str, QuestionsObj) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to   = "aaaaeeeeiiiioooouuuunc------";
  for (var i=0, l=from.length ; i<l ; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes

  // make sure url is unique
  let s = str;
  for (let b = 0; b < QuestionsObj.length; b++) {
    let n = 2;
    
    //console.log(QuestionsObj[s].url);
    if (QuestionsObj[b].url === '/' + str) {

      // if ends in a number
      let endsInNum = str.match(/\d+$/);
      let number;
      if (endsInNum) {
        number = endsInNum[0];
        number = parseInt(number, 10);
        s = str + '-' + (n + number);
      } else {
        s = str + '-' + n;
      }

      break;
    }
    
  }

  return s;
}

function createObject() {

  const reader = new FileReader();
  const file = "/data/CYOA Object.xlsx";

  let QuestionsObj = [];
  let SolutionsObj = [];

  fetch(file).then(function(response) {
    return response.blob();
  }).then(function(myBlob) {
    reader.readAsBinaryString(myBlob);
  });

  reader.addEventListener('loadend', (e) => {

    // parse the workbook
    let Workbook = XLSX.read(e.target.result, {type: 'binary', cellDates:true, cellStyles:true});

    // questions object
    let QuestionsSheet = XLSX.utils.sheet_to_json(Workbook.Sheets.Questions);
    let OptionsSheet = XLSX.utils.sheet_to_json(Workbook.Sheets.Options);
    let NextSheet = XLSX.utils.sheet_to_json(Workbook.Sheets.Next);
    
    for (let s = 0; s < OptionsSheet.length; s++) {

      // get question
      let Question = OptionsSheet[s].Question;

      // get multiple choice boolean
      let MultipleChoice = QuestionsSheet[s]['Multiple Choice?'];

      // get template string
      let Template = QuestionsSheet[s]['Template'];

      // get options as an array
      let OptionsArray = [];

      let OptionsLength = Object.keys(OptionsSheet[s]);
      OptionsLength = OptionsLength.length - 1;

      for (let q = 0; q < OptionsLength; q++) {
        OptionsArray.push(OptionsSheet[s]['Option '+(q+1)]);
      }

      // get nexts as an array
      let NextsArray = [];

      let NextsLength = Object.keys(NextSheet[s]);
      NextsLength = NextsLength.length - 1;

      for (let q = 0; q < NextsLength; q++) {
        NextsArray.push(NextSheet[s]['Option ' + (q+1) + ' Next']);
      }

      // get solutions
      let SolutionsObj = [];
      let SheetsLength = Object.keys(Workbook.Sheets);

      for (let z = 0; z < SheetsLength.length; z++) {
        if (SheetsLength[z] === 'Questions' || SheetsLength[z] === 'Options' || SheetsLength[z] === 'Next' || SheetsLength[z] === 'Solutions') {
          continue;
        }

        let SolutionArray = [];

        let SolutionName = SheetsLength[z];
        let SolutionSheet = XLSX.utils.sheet_to_json(Workbook.Sheets[SolutionName]);

        for (let q = 0; q < OptionsLength; q++) {
          SolutionArray.push(SolutionSheet[s]['Option ' + (q+1) + ' Weight']);
        }

        let SolutionObj = {
          [SolutionName] : SolutionArray
        }

        SolutionsObj.push(SolutionObj);
        
      }

      let QuestionObj = {
        'question' : Question,
        'multi' : MultipleChoice,
        'template' : Template,
        'options' : OptionsArray,
        'next' : NextsArray,
        'url' : '/' + string_to_slug(Question, QuestionsObj),
        'solutions' : SolutionsObj
      };
      QuestionsObj.push(QuestionObj);

    }

    console.log(QuestionsObj);

    // solutions object
    let SolutionsSheet = XLSX.utils.sheet_to_json(Workbook.Sheets.Solutions);

    for (let s = 0; s < SolutionsSheet.length; s++) {

      // get solution
      let SolutionName = SolutionsSheet[s].Solution;
      let SolutionCategory = SolutionsSheet[s].Category;
      let SolutionIcon = SolutionsSheet[s].Icon;
      let SolutionInformation = SolutionsSheet[s].Information;

      let SolutionObj = {
        'solution' : SolutionName,
        'category' : SolutionCategory,
        'icon' : SolutionIcon,
        'information' : SolutionInformation
      };
      SolutionsObj.push(SolutionObj);

    }

    console.log(SolutionsObj);

  });

}

//createObject();

export const Questions = [
  {
    "question": "What industry are you in?",
    "multi": "False",
    "template": "tiled-icon",
    "options": [
      "Retail",
      "Government",
      "Banking & Insurance",
      "Education",
      "Energy & Utilities",
      "Telecommunications",
      "Healthcare & Pharmaceuticals",
      "Other"
    ],
    "next": [
      "1",
      "1",
      "1",
      "1",
      "1",
      "1",
      "1",
      "1"
    ],
    "url": "/what-industry-are-you-in",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "What is your annual turn over?",
    "multi": "False",
    "template": "list-icon",
    "options": [
      "$2m – $5m",
      "$5m – $10m",
      "$10m – $20m",
      "$20m +"
    ],
    "next": [
      "2",
      "2",
      "2",
      "2"
    ],
    "url": "/what-is-your-annual-turn-over",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "What do you need help with?",
    "multi": "True",
    "template": "list",
    "options": [
      "Servicing regional and rural customers",
      "Digitising an existing process",
      "Issuing or renewing an accreditation or license",
      "Selling goods or services online",
      "Making it easier for your customers to pay",
      "Reconciling incoming payments",
      "Rewards and Cash Disbursement"
    ],
    "next": [
      "3",
      "5",
      "16",
      "22",
      "29",
      "37",
      "44"
    ],
    "url": "/what-do-you-need-help-with",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "1",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0",
          "1",
          "1",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "1"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "1",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0",
          "1",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "When servicing regional and rural customers, how do you need to serviced them?",
    "multi": "False",
    "template": "list",
    "options": [
      "Online",
      "In-person",
      "Multi-channel"
    ],
    "next": [
      "4",
      "4",
      "4"
    ],
    "url": "/when-servicing-regional-and-rural-customers-how-do-you-need-to-serviced-them",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "1",
          "1"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Who pays for the transactions?",
    "multi": "False",
    "template": "list",
    "options": [
      "Your customer",
      "You do"
    ],
    "next": [
      "46",
      "46"
    ],
    "url": "/who-pays-for-the-transactions",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "When digitising an existing process, do you want to move online only, or multi-channel?",
    "multi": "False",
    "template": "list",
    "options": [
      "Online only",
      "Multi-channel"
    ],
    "next": [
      "6",
      "6"
    ],
    "url": "/when-digitising-an-existing-process-do-you-want-to-move-online-only-or-multi-channel",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you need to collect data, such as an online form?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "7",
      "7"
    ],
    "url": "/do-you-need-to-collect-data-such-as-an-online-form",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Does your process include a level of identity requirement?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "10",
      "8"
    ],
    "url": "/does-your-process-include-a-level-of-identity-requirement",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do they need to be confirmed as eligible?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "9",
      "9"
    ],
    "url": "/do-they-need-to-be-confirmed-as-eligible",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Does the level of assurance include a regulatory requirement?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes, Level 1",
      "Yes, Level 2",
      "Yes, Level 3",
      "Yes, Level 4 document check?",
      "No"
    ],
    "next": [
      "10",
      "10",
      "10",
      "10",
      "10"
    ],
    "url": "/does-the-level-of-assurance-include-a-regulatory-requirement",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you required third party integration into other databases?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "11",
      "11"
    ],
    "url": "/do-you-required-third-party-integration-into-other-databases",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you require a payment collection?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "13",
      "12"
    ],
    "url": "/do-you-require-a-payment-collection",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "How would you like to collect the payment?",
    "multi": "False",
    "template": "list",
    "options": [
      "Alternative payment services such as Paypal",
      "Credit Card",
      "Bank to Bank",
      "Direct Debt",
      "NPP"
    ],
    "next": [
      "13",
      "13",
      "13",
      "13",
      "13"
    ],
    "url": "/how-would-you-like-to-collect-the-payment",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "1",
          "1",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "1",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "1",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you need a photo taken and verified?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "14",
      "14"
    ],
    "url": "/do-you-need-a-photo-taken-and-verified",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you require a data delivery to a third party or agency?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes, electronic",
      "Yes, paper",
      "Yes, other",
      "Yes, a combination of these",
      "No"
    ],
    "next": [
      "15",
      "15",
      "15",
      "15",
      "15"
    ],
    "url": "/do-you-require-a-data-delivery-to-a-third-party-or-agency",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you require proof or a generation of a certification?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "46",
      "46"
    ],
    "url": "/do-you-require-proof-or-a-generation-of-a-certification",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "When issuing or renewing a license, do you need to collect data, such as an online form?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "17",
      "17"
    ],
    "url": "/when-issuing-or-renewing-a-license-do-you-need-to-collect-data-such-as-an-online-form",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Does your process include a level of identity requirement?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "18",
      "18"
    ],
    "url": "/does-your-process-include-a-level-of-identity-requirement-2",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you require adjudication for eligibility?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "19",
      "19"
    ],
    "url": "/do-you-require-adjudication-for-eligibility",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you need a photo taken and verified?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "20",
      "20"
    ],
    "url": "/do-you-need-a-photo-taken-and-verified-2",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you need the accreditation printed or delivered electronically?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes, electronic",
      "Yes, paper",
      "Yes, both",
      "No"
    ],
    "next": [
      "21",
      "21",
      "21",
      "21"
    ],
    "url": "/do-you-need-the-accreditation-printed-or-delivered-electronically",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "In what channel do you want to offer the service?",
    "multi": "False",
    "template": "list",
    "options": [
      "Online only",
      "In-person, at Post Office",
      "Both"
    ],
    "next": [
      "46",
      "46",
      "46"
    ],
    "url": "/in-what-channel-do-you-want-to-offer-the-service",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "When selling goods and services online, where do you sell?",
    "multi": "False",
    "template": "list",
    "options": [
      "In Australia",
      "Internationally",
      "Both"
    ],
    "next": [
      "23",
      "23",
      "23"
    ],
    "url": "/when-selling-goods-and-services-online-where-do-you-sell",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "How are you currently transacting online?",
    "multi": "False",
    "template": "list",
    "options": [
      "We don't accept payments online",
      "We use alternative payment services such as Paypal",
      "Credit Card",
      "Bank to Bank",
      "Direct Debit",
      "NPP"
    ],
    "next": [
      "24",
      "24",
      "24",
      "24",
      "24",
      "24"
    ],
    "url": "/how-are-you-currently-transacting-online",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0",
          "1",
          "1",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "1",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "1",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "How would you like to transact online?",
    "multi": "False",
    "template": "list",
    "options": [
      "Alternative payment services such as Paypal",
      "Credit Card",
      "Bank to Bank",
      "Direct Debit",
      "NPP"
    ],
    "next": [
      "25",
      "25",
      "25",
      "25",
      "25"
    ],
    "url": "/how-would-you-like-to-transact-online",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "1",
          "1",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "1",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "1",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you have any issues with fraud?",
    "multi": "False",
    "template": "list",
    "options": [
      "No",
      "We need help",
      "It's a large problem"
    ],
    "next": [
      "26",
      "26",
      "26"
    ],
    "url": "/do-you-have-any-issues-with-fraud",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "1",
          "1"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "How do you handle logistics?",
    "multi": "False",
    "template": "list",
    "options": [
      "In house warehousing",
      "Pick and pack service",
      "Not sure"
    ],
    "next": [
      "27",
      "27",
      "27"
    ],
    "url": "/how-do-you-handle-logistics",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you need to handle customer enquires & complaints?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "28",
      "28"
    ],
    "url": "/do-you-need-to-handle-customer-enquires-complaints",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "1",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you have any loyalty programs?",
    "multi": "False",
    "template": "list",
    "options": [
      "Yes",
      "No"
    ],
    "next": [
      "46",
      "46"
    ],
    "url": "/do-you-have-any-loyalty-programs",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "1",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you have an issue with getting paid on time?",
    "multi": "False",
    "template": "list",
    "options": [
      "No",
      "Yes"
    ],
    "next": [
      "31",
      "30"
    ],
    "url": "/do-you-have-an-issue-with-getting-paid-on-time",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "What do you believe the reasons are?",
    "multi": "False",
    "template": "list",
    "options": [
      "Payments fail",
      "Customers loosing bills",
      "The bills are not convenient to pay"
    ],
    "next": [
      "31",
      "31",
      "31"
    ],
    "url": "/what-do-you-believe-the-reasons-are",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you have an issue with the payment methods?",
    "multi": "False",
    "template": "list",
    "options": [
      "No",
      "Yes"
    ],
    "next": [
      "34",
      "32"
    ],
    "url": "/do-you-have-an-issue-with-the-payment-methods",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "What do you currently offer?",
    "multi": "False",
    "template": "list",
    "options": [
      "EFT",
      "Credit Card",
      "Bank to Bank",
      "Payment through an App",
      "Direct Debit"
    ],
    "next": [
      "33",
      "33",
      "33",
      "33",
      "33"
    ],
    "url": "/what-do-you-currently-offer",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "What do you want offer?",
    "multi": "False",
    "template": "list",
    "options": [
      "EFT",
      "Credit Card",
      "Bank to Bank",
      "Payment through an App",
      "Direct Debit",
      "NPP",
      "Barcode",
      "In store"
    ],
    "next": [
      "34",
      "34",
      "34",
      "34",
      "34",
      "34",
      "34",
      "34"
    ],
    "url": "/what-do-you-want-offer",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "1",
          "0",
          "1",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "1"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "1",
          "1",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you need to consolidate multiple bills to a single customer?",
    "multi": "False",
    "template": "list",
    "options": [
      "No",
      "Yes"
    ],
    "next": [
      "35",
      "35"
    ],
    "url": "/do-you-need-to-consolidate-multiple-bills-to-a-single-customer",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you have customers in regional & rural areas?",
    "multi": "False",
    "template": "list",
    "options": [
      "No",
      "Yes"
    ],
    "next": [
      "46",
      "36"
    ],
    "url": "/do-you-have-customers-in-regional-rural-areas",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "When servicing regional and rural customers, how do you need to serviced them?",
    "multi": "False",
    "template": "list",
    "options": [
      "Online",
      "In-person",
      "Multi-channel"
    ],
    "next": [
      "46",
      "46",
      "46"
    ],
    "url": "/when-servicing-regional-and-rural-customers-how-do-you-need-to-serviced-them-2",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "1",
          "1"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you have trouble reconciling payments because?",
    "multi": "False",
    "template": "list",
    "options": [
      "I don’t know what someone is paying for",
      "I don't know who is paying me",
      "None of these"
    ],
    "next": [
      "38",
      "40",
      "42"
    ],
    "url": "/do-you-have-trouble-reconciling-payments-because",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Is it trouble with invoice numbering?",
    "multi": "False",
    "template": "list",
    "options": [
      "No",
      "Yes"
    ],
    "next": [
      "39",
      "39"
    ],
    "url": "/is-it-trouble-with-invoice-numbering",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "How are customers currently paying you?",
    "multi": "False",
    "template": "list",
    "options": [
      "EFT",
      "Credit Card",
      "Bank to Bank",
      "Payment through an App",
      "Direct Debit"
    ],
    "next": [
      "40",
      "40",
      "40",
      "40",
      "40"
    ],
    "url": "/how-are-customers-currently-paying-you",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Is it trouble with customer numbering?",
    "multi": "False",
    "template": "list",
    "options": [
      "No",
      "Yes"
    ],
    "next": [
      "41",
      "41"
    ],
    "url": "/is-it-trouble-with-customer-numbering",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "How are customers currently paying you?",
    "multi": "False",
    "template": "list",
    "options": [
      "EFT",
      "Credit Card",
      "Bank to Bank",
      "Payment through an App",
      "Direct Debit"
    ],
    "next": [
      "42",
      "42",
      "42",
      "42",
      "42"
    ],
    "url": "/how-are-customers-currently-paying-you-2",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you have an accounts receivable?",
    "multi": "False",
    "template": "list",
    "options": [
      "No",
      "Yes"
    ],
    "next": [
      "46",
      "43"
    ],
    "url": "/do-you-have-an-accounts-receivable",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "How many people are there?",
    "multi": "False",
    "template": "list",
    "options": [
      "0-5",
      "5-10",
      "10+"
    ],
    "next": [
      "46",
      "46",
      "46"
    ],
    "url": "/how-many-people-are-there",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "I need a disbursement solution for my employees or customers for",
    "multi": "False",
    "template": "list",
    "options": [
      "Rewards and Recognition",
      "Expense and travel management",
      "Over or under payments"
    ],
    "next": [
      "45",
      "45",
      "45"
    ],
    "url": "/i-need-a-disbursement-solution-for-my-employees-or-customers-for",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "Do you need a one time use or a repeatable solution?",
    "multi": "False",
    "template": "list",
    "options": [
      "Single use",
      "Repeatable"
    ],
    "next": [
      "46",
      "46"
    ],
    "url": "/do-you-need-a-one-time-use-or-a-repeatable-solution",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "1",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "1"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0"
        ]
      }
    ]
  },
  {
    "question": "How do you want to support/service/connect to your customer?",
    "multi": "False",
    "template": "list",
    "options": [
      "Online",
      "In-person",
      "Multi-channel"
    ],
    "next": [
      "9999",
      "9999",
      "9999"
    ],
    "url": "/how-do-you-want-to-support-service-connect-to-your-customer",
    "solutions": [
      {
        "Online smart form applications": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store data capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant electronic verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "In store identity verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Back office entitlement check": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Automated eligibility checks": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Qualification verification": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Physical license production": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Instant digital licensing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online secure vault": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Renewal processing": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "CMS entitlement management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Scanning and image capture": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Digitisation of data": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Banking services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bill payments management": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Bank to bank transfer": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Cash disbursement": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Merchant services": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Online payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Pre-paid business card": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Recurring payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Loyalty": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Fraud": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Alternative Payments": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Physical": [
          "0",
          "0",
          "0"
        ]
      },
      {
        "Delivery - Digital": [
          "0",
          "0",
          "0"
        ]
      }
    ]
  }
];

export const Solutions = [
  {
    "solution": "Online smart form applications",
    "category": "Identity",
    "icon": "OnlineSmartFormApplications",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "In store data capture",
    "category": "Identity",
    "icon": "InStoreDataCapture",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Instant electronic verification",
    "category": "Identity",
    "icon": "InstantElectronicVerification",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "In store identity verification",
    "category": "Identity",
    "icon": "InStoreIdentityVerification",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Back office entitlement check",
    "category": "Identity",
    "icon": "BackOfficeEntitlementCheck",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Automated eligibility checks",
    "category": "Identity",
    "icon": "AutomatedEligibilityChecks",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Qualification verification",
    "category": "Identity",
    "icon": "QualificationVerification",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Physical license production",
    "category": "Identity",
    "icon": "PhysicalLicenseProduction",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Instant digital licensing",
    "category": "Identity",
    "icon": "InstantDigitalLicensing",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Online secure vault",
    "category": "Identity",
    "icon": "OnlineSecureVault",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Renewal processing",
    "category": "Identity",
    "icon": "RenewalProcessing",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "CMS entitlement management",
    "category": "Identity",
    "icon": "CMSEntitlementManagement",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Scanning and image capture",
    "category": "Identity",
    "icon": "ScanningAndImageCapture",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Digitisation of data",
    "category": "Identity",
    "icon": "DigitisationOfData",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Bank to bank transfer",
    "category": "Pay",
    "icon": "BankToBankTransfer",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Banking services",
    "category": "Pay",
    "icon": "BankingServices",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Bill payments management",
    "category": "Pay",
    "icon": "BillPaymentsManagement",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Cash disbursement",
    "category": "Pay",
    "icon": "CashDisbursement",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Merchant services",
    "category": "Pay",
    "icon": "MerchantServices",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Online payments",
    "category": "Pay",
    "icon": "OnlinePayments",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Pre-paid business card",
    "category": "Pay",
    "icon": "PrePaidBusinessCard",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Recurring payments",
    "category": "Pay",
    "icon": "RecurringPayments",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Loyalty",
    "category": "Pay",
    "icon": "Loyalty",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Fraud",
    "category": "Pay",
    "icon": "Fraud",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Alternative Payments",
    "category": "Pay",
    "icon": "AlternativePayments",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Delivery - Physical",
    "category": "Deliver",
    "icon": "DeliveryPhysical",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  },
  {
    "solution": "Delivery - Digital",
    "category": "Deliver",
    "icon": "DeliveryDigital",
    "information": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id erat nec velit consequat dapibus sed in libero. Nulla nec augue non nisi maximus elementum. Pellentesque sollicitudin urna ac hendrerit lobortis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos."
  }
];


// WEBPACK FOOTER //
// ./src/Data.js